import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const DISMISS_KEY = "vt_pwa_dismissed";

export const PwaInstallNudge = () => {
    const [deferred, setDeferred] = useState(null);

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            if (localStorage.getItem(DISMISS_KEY) === "1") return;
            setDeferred(e);
        };
        window.addEventListener("beforeinstallprompt", handler);
        return () => window.removeEventListener("beforeinstallprompt", handler);
    }, []);

    if (!deferred) return null;

    const install = async () => {
        deferred.prompt();
        try { await deferred.userChoice; } catch { /* dismissed */ }
        setDeferred(null);
    };
    const dismiss = () => {
        localStorage.setItem(DISMISS_KEY, "1");
        setDeferred(null);
    };

    return (
        <div
            data-testid="pwa-install-nudge"
            className="fixed left-4 right-4 sm:left-auto sm:right-4 sm:w-[340px] bottom-24 md:bottom-4 z-[60] rounded-2xl bg-[#0F3311] text-white shadow-2xl p-3.5 flex items-center gap-3 vt-fade-up"
        >
            <span className="h-10 w-10 rounded-xl bg-white/10 flex items-center justify-center shrink-0">
                <Download className="h-5 w-5" />
            </span>
            <div className="flex-1 min-w-0">
                <p className="text-[13px] font-bold leading-tight">Install Family Repository</p>
                <p className="text-[11px] text-white/70 leading-snug">One tap from your home screen — works offline too.</p>
            </div>
            <button
                type="button"
                onClick={install}
                data-testid="pwa-install-btn"
                className="px-3 py-1.5 rounded-full bg-[#F57C00] hover:bg-[#d96d00] text-[12px] font-bold shrink-0 transition-colors"
            >
                Install
            </button>
            <button
                type="button"
                onClick={dismiss}
                aria-label="Dismiss install prompt"
                data-testid="pwa-install-dismiss"
                className="p-1 rounded-full text-white/60 hover:bg-white/10 shrink-0 transition-colors"
            >
                <X className="h-3.5 w-3.5" />
            </button>
        </div>
    );
};
